import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { scrollToElement } from '@lib/scroller';

export default class FeaturedSpec extends Component {
  static propTypes = {
    featuredSpec: PropTypes.array,
    hotSpec: PropTypes.array,
    noFeaturedSpecText: PropTypes.string,
  };

  state = {
    allowFullHeight: false,
    isCollapsed: true,
  };

  componentDidMount() {
    var specListFullHeight = this.refs.specList?.scrollHeight;
    var MAXIMUM_COLLAPSED_HEIGHT = 360;

    if (specListFullHeight <= MAXIMUM_COLLAPSED_HEIGHT) {
      this.setState({ allowFullHeight: true });
    }
  }

  scrollToSummaryTop = () => {
    var featuredSpec = document.querySelector('[data-element=featured-spec]');
    scrollToElement(featuredSpec);
  };

  toggleSpecCollapsed = () => {
    this.setState({ isCollapsed: !this.state.isCollapsed });
    if (!this.state.isCollapsed) {
      this.scrollToSummaryTop();
    }
  };

  render() {
    return (
      <>
        {this.props.hotSpec.length > 0 || this.props.featuredSpec.length > 0 ? (
          <div className="ch-col--12 sm:ch-col--6 lg:ch-col--7">
            <h3>Featured specification</h3>
            <div data-element="featured-spec">
              <ul
                className={classNames(
                  'ch-clearfix ch-list ac-product__featured',
                  { 'ac-product__featured--collapsed': this.state.isCollapsed },
                  {
                    'ac-product__featured--full-height':
                      this.state.allowFullHeight,
                  }
                )}
                ref="specList"
              >
                {this.props.hotSpec.map((spec) => (
                  <li key={spec}>{spec}</li>
                ))}
                {this.props.featuredSpec.map((spec) => (
                  <li key={spec}>{spec}</li>
                ))}
              </ul>
              <button
                className="ch-btn ch-btn--block ch-btn--sm ch-btn--link js-off--hide ac-product__featured-show-more"
                onClick={this.toggleSpecCollapsed}
                type="button"
              >
                {this.state.isCollapsed ? 'Show more' : 'Show less'}
              </button>
            </div>
          </div>
        ) : (
          this.props.noFeaturedSpecText
        )}
      </>
    );
  }
}
